import apiClient from './apiClient';

export const mapFaqFromApi = (f, index = 0) => ({
  id: f._id ?? f.id ?? `faq-${index}`,
  question: f.question ?? '',
  answer: f.answer ?? '',
});

export const getFaqs = async () => {
  const { data } = await apiClient.get('/api/faq');
  if (!Array.isArray(data)) return [];
  return data.map((f, i) => mapFaqFromApi(f, i));
};

export const saveFaqs = async (items) => {
  const payload = (items || []).map((i) => ({
    question: i.question ?? '',
    answer: i.answer ?? '',
  }));
  const { data } = await apiClient.put('/api/faq', payload);
  if (!Array.isArray(data)) return [];
  return data.map((f, i) => mapFaqFromApi(f, i));
};

